import {IAuthenticationService} from '../authentication.service';

export class LoginController {

    public static $inject = [ 'authenticationService', '$stateParams' ];

    public constructor(
        private authenticationService: IAuthenticationService,
        private $stateParams: any 
        ) {

        this.activate();
    }

    public activate() {
        this.authenticationService.login(this.$stateParams.appState);
    }
}
